import React, { 
    useState, 
    useEffect,
    useCallback } from 'react';
import {
    Button,
    Form,
    Input,
    Alert,
    Modal,
    notification,
    Result
} from 'antd';
import MaskedInput from "antd-mask-input";
import { 
    useGoogleReCaptcha,
    GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import axios from 'axios';
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    QuestionOutlined,
    SmileOutlined,
} from '@ant-design/icons';

//import DefaultMenu from './contact/DefaultMenu';

const siteDomain = headerVars.siteDomain;

function SwapForm( { handleOpenQuestionModal, setAutoSwapDate } ) {
    const [ customerID, setCustomerID ] = useState( '' );
    const [ customerIdValidSuffix, setCustomerIdValidSuffix ] = useState( <></> );
    const [ customerMACValidSuffix, setCustomerMACValidSuffix ] = useState( <></> );
    const [ customerMAC, setCustomerMAC ] = useState( '' );
    const [ customerIDValid, setCustomerIDValid ] = useState( false );
    const [ customerMACValid, setCustomerMACValid ] = useState( false );
    const [ formSubmitting, setFormSubmitting ] = useState( false );
    const [ modemSwapping, setModemSwapping ] = useState( false );
    const [modalOpen, setModalOpen] = useState(false);
    const [submissionResult, setSubmissionResult] = useState(<></>);
    const [showForm, setShowForm] = useState(true);
    const [customerCredentialsValidated, setCustomerCredentialsValidated] = useState(false);
    //const [ swapDateCompletedManually, setSwapDateCompletedManually ] = useState( false );
    //const { executeRecaptcha } = useGoogleReCaptcha();
    const [form] = Form.useForm();
    const siteDomain = headerVars.siteDomain;

    const [api, contextHolder] = notification.useNotification();

    const captchaKey = "6LdmP8QkAAAAACX1XkPWEZ08HGoIkk1nClZiagMJ";

    useEffect(() => {}, []);

    const handleOnInputChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;
        validateInput( currentVal, inputID );
    }

    const validateInput = ( currentVal, inputId ) => {
        let isValid = true;
        let validationSuffix = <></>;

        switch( inputId ) {
            case 'modem-swap-customer-id': 
                if( currentVal.length < 4 ){ 
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerID = isValid ? currentVal : '';

                setCustomerIDValid( isValid );
                setCustomerID( customerID );
                setCustomerIdValidSuffix( validationSuffix );
                
                if( !isValid ) { }
            break;

            case 'modem-swap-mac-address':                 
                if( !currentVal.match(/^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/) ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerMACAddr = isValid ? currentVal : '';

                setCustomerMAC( customerMACAddr );
                setCustomerMACValidSuffix( validationSuffix );
                setCustomerMACValid( isValid );

                if( !isValid ) { }
            break;
        }
    }

    const handleReCaptchaVerify = useCallback(async () => {
        //if (!executeRecaptcha) {
          //console.log('Execute recaptcha not yet available');
          //return;
        //}

        setSubmissionResult(<></>);
        setFormSubmitting( true );

        //const token = await executeRecaptcha('success');
        const token = '123456fdsdf878sdf89s7f9s8df879s8df798sdf79sdf8sdf';
        //console.log("token: ", token);
        //console.log('customerMAC::', customerMAC);

        let form_data = new FormData;
        form_data.append('action', 'startca_handle_modem_swap_rogers_customer_validation');
        form_data.append('token', token);
        form_data.append('customer_id', customerID);
        form_data.append('customer_mac', customerMAC);

        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            let resultObj = JSON.parse( response.data.result )
            console.log( 'response:: ', response );
            console.log( 'result:: ', resultObj );

            // if( response.data.body ) {
            //     result = response.data.body.Status;
            //     if( response.data.body.AutoSwapDate && response.data.body.AutoSwapDate != '') {
            //         let swapDateDirty = new Date( response.data.body.AutoSwapDate ); 
            //         let swapDatePretty = swapDateDirty.toDateString();
            //         setAutoSwapDate( [<p>Your automatic swap date is <span style={{ fontWeight: '600' }}>{ swapDatePretty }</span>.</p>] );
            //     }
            // }

            //385277H
            //F8:34:5A:80:8F:F4


            if( response.data ) {
                if( response.data.httpcode == 200 ) {
                    if( resultObj.body ) {
                        if( resultObj.body.ManualSwapDate != "" ||
                            resultObj.body.AutomatedSwapDateCompletedAt != "" 
                        ) {
                            setShowForm( false );
                            setSubmissionResult( 
                                <Result
                                    status="warning"
                                    title="Your modem swap has already been processed!"
                                    subTitle="Please plugin your new modem and try your connection."
                                    extra={[]}
                                />
                            );
                        }
                        else {
                            setFormSubmitting( false );
                            openNotification('bottom', '');
                            setCustomerCredentialsValidated( true );
                        }
                    }
                } else {
                    setFormSubmitting( false );
                    setSubmissionResult( 
                        <Result
                            status="error"
                            title="Submission failed!"
                            subTitle="There was a problem submitting your request. Please try again later."
                            extra={[]}
                        />
                    );
                }
            } else {
                setFormSubmitting( false );
                setSubmissionResult( 
                    <Result
                        status="error"
                        title="Submission failed!"
                        subTitle="There was a problem submitting your request. Please try again later."
                        extra={[]}
                    />
                );
            }
        })
        .catch(function ( error ) {
            setFormSubmitting( false );
            setSubmissionResult( 
                <Result
                    status="error"
                    title="Submission failed!"
                    subTitle="Please double check that your customer id and mac address is correct and try again."
                    extra={[]}
                />
             );

            if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                console.log(error.request);
            } else {
                console.log('Error: ', error);
            }
        })
        .finally(function () {
            // always executed 
        });

    }, [/*executeRecaptcha*/,
        setFormSubmitting,
        setAutoSwapDate,
        customerMAC,
        customerID,
    ]);

    const handlePerformModemSwap = () => {
        let form_data = new FormData;
        form_data.append('action', 'startca_handle_do_modem_swap');
        form_data.append('customer_id', customerID);
        form_data.append('customer_mac', customerMAC);

        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};
        setModemSwapping( true );

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            //console.log( 'response error:: ', response.data.error );
            console.log( 'response:: ', response ); 
            //console.log( 'result:: ', response.data.result );
            //F8:34:5A:80:98:64
            //L53653X

            if( response.data ) {
                if( response.data == 200 ) {
                    setModemSwapping( false );
                    setShowForm( false );
                    setSubmissionResult( 
                        <Result
                            status="success"
                            title="Your modem has been swapped successfully!"
                            subTitle="."
                            extra={[]}
                        />
                    );
                } else {
                    setModemSwapping( false );
                    setShowForm( false );
                    setSubmissionResult( 
                        <Result
                            status="error"
                            title="Submission failed!"
                            subTitle="There was a problem submitting your request. Please try again later."
                            extra={[]}
                        />
                    );
                }
            } else {
                setModemSwapping( false );
                setSubmissionResult( 
                    <Result
                        status="error"
                        title="Submission failed!"
                        subTitle="There was a problem submitting your request. Please try again later."
                        extra={[]}
                    />
                );
            }
        })
        .catch(function ( error ) {
            setModemSwapping( false );
            setSubmissionResult( 
                <Result
                    status="error"
                    title="Submission failed!"
                    subTitle="There was a problem submitting your request. Please try again later."
                    extra={[]}
                />
            );
        })
        .finally(function () {
            // always executed
        });
    }

    const openNotification = ( placement, formName ) => {
        api.info({
            message: "Credentials validated.",
            description: "Select 'Complete modem swap now' to complete the process.",
            placement,
            icon: (
                <SmileOutlined
                  style={{
                    color: '#52c41a',
                  }}
                />
            ),

        });
    }

    return (
        <>
            <Form 
                form={ form } 
                style={{ 'display': ( showForm  ) ? 'block' : 'none' }}
            > 
                <div className="form-column-row">
                    <Form.Item
                        label="Customer ID"
                        labelCol={{ span: 24 }}
                        name="customerid"
                        style={{paddingRight:'1rem'}}
                        rules={[
                            {
                            required: true,
                            message: 'Please input your customer id!',
                            },
                        ]}
                    >
                        <Input
                            id="modem-swap-customer-id"
                            suffix={ customerIdValidSuffix }
                            autoFocus
                            onChange={handleOnInputChange}
                            defaultValue={ customerID }
                        />
                    </Form.Item>
                    <Form.Item
                        label="MAC Address"
                        labelCol={{ span: 24 }}
                        name="macaddress"
                        rules={[
                            {
                            required: true,
                            message: 'Please input your current modems MAC address!',
                            }
                        ]}
                    >
                        <Button 
                            id="modem-swap-question-button"
                            type="primary" 
                            size='small'
                            shape="circle"
                            onClick={ handleOpenQuestionModal } 
                            icon={ <QuestionOutlined /> }
                        />
                        <MaskedInput
                            id="modem-swap-mac-address"
                            mask={ [
                                {
                                mask: 'dd:dd:dd:dd:dd:dd',
                                blocks: {
                                    d: {
                                    mask: '*'
                                    }
                                }
                                }
                            ] }
                            suffix={ customerMACValidSuffix }
                            onChange={handleOnInputChange}
                            defaultValue={ customerMAC }
                        />
                    </Form.Item>
                    <Button 
                        className='g-recaptcha'
                        onClick={ handleReCaptchaVerify }
                        loading={ formSubmitting }
                        type="primary"
                        disabled={ ( customerIDValid && customerMACValid && !customerCredentialsValidated ) ? false : true }
                    >Validate credentials</Button>
                </div>
                <div className='swap-button-container'>
                    <Button 
                        className=''
                        onClick={ handlePerformModemSwap }
                        loading={ modemSwapping }
                        type="primary"
                        //style={{ display: () ? 'block' : 'none' }}
                        disabled={ ( customerCredentialsValidated ) ? false : true }
                    >Complete modem swap now!</Button>
                </div>
            </Form>
            { submissionResult }
            { contextHolder }
        </>
    )
}

export default SwapForm